import React from 'react';
import { SvgCircleIcon, IconComponent, IconGlyphComponent } from '@shapeable/icons';

export const FoodIcon: IconComponent = (props) => (
  <SvgCircleIcon { ...props } glyphWidth={96} glyphHeight={96}>
    
  </SvgCircleIcon>
);

export const FoodIconGlyph: IconGlyphComponent = (props) => <FoodIcon { ...props } variant='glyph' />;